import React from "react";
import type { ReactNode } from "react";
import cx from "classnames";

import { Heading } from "common/ui/Heading";
import { Paragraph } from "common/ui/Paragraph";

import { useWindowResize } from "common/middleware/hooks";

import styles from "./SelectRow.module.scss";

interface Props {
  row: { id?: string | number, onClick?: () => void, items: ReactNode[] },
  isSelected?: boolean,
  children: ReactNode,
}

export function SelectRow({ row, isSelected, children }: Props) {
  const [windowWidth] = useWindowResize();

  const isWidthLessThan768 = windowWidth < 768;

  return (
    <tr
      className={cx(styles.SelectRow, {
        [styles.Linked]: row?.onClick,
        [styles.Selected]: isSelected,
      })}
      onClick={row?.onClick}
      data-testid="select-row"
    >
      <td data-testid="row-checkbox">{children}</td>
      {row?.items.map((item, i) => {
        if (!item) {
          return;
        }

        if (typeof item === "string") {
          if (i === 0 && isWidthLessThan768) {
            return (
              <td key={i}>
                <Heading variant="h3">{item}</Heading>
              </td>
            )
          }

          return (
            <td key={i}>
              <Paragraph variant="p1">{item}</Paragraph>
            </td>
          )
        }

        return <td key={i}>{item}</td>
      })}
    </tr>
  )
}

